import { lazy, useEffect } from 'react'
import { useConfigurationContext } from '@nv/contexts'
import { useHandleLogout, useInactivityTimer } from '@nv/hooks'
import useNVModal from '../modal_master/nv_modal/useNVModal'

const VoterInactivity = lazy(() => import('@nv/lazy-loadable/lib/modals/VoterInactivity'))

export function VoterInactivityTimer() {
  const { showVoterInactivityModal, voterInactivityWarningMins } = useConfigurationContext()
  const { NVModal, openModal, closeModal } = useNVModal()
  const handleLogout = useHandleLogout()

  const isAdminPage = window.location.pathname?.startsWith('/admin')
  const enabled = !isAdminPage && !!showVoterInactivityModal

  const { isWarning, reset } = useInactivityTimer((voterInactivityWarningMins ?? 14) * 60 * 1000, enabled)

  useEffect(() => {
    if (isWarning) openModal()
  }, [isWarning])

  if (!enabled) return null

  return (
    <NVModal>
      <VoterInactivity
        onStay={() => {
          reset()
          closeModal()
        }}
        onTimeout={() => {
          closeModal()
          handleLogout()
        }}
      />
    </NVModal>
  )
}
